import React from 'react';
import styled from 'styled-components';

import { bpMaxSM, bpMaxLG, bpMaxMD, bpMaxXXS } from '../utils/breakpoints';

export const PREVIEW_SIZES = {
	LARGE: 'large',
	MEDIUM: 'medium',
	SMALL: 'small',
	EXTRA_SMALL: 'x-small',
};

const IMAGE_SIZES = {
	[PREVIEW_SIZES.LARGE]: '90px',
	[PREVIEW_SIZES.MEDIUM]: '90px',
	[PREVIEW_SIZES.SMALL]: '90px',
	[PREVIEW_SIZES.EXTRA_SMALL]: '90px',
};

const FONT_SIZES = {
	[PREVIEW_SIZES.LARGE]: '2.5rem',
	[PREVIEW_SIZES.MEDIUM]: '2.5rem',
	[PREVIEW_SIZES.SMALL]: '2.5rem',
	[PREVIEW_SIZES.EXTRA_SMALL]: '2.5rem',
};

const Container = styled.article`
	--border-light: rgba(239, 241, 245, 0.2);
	--border-dark: rgba(239, 241, 245, 0.2);

	display: flex;
	div.artist-image img {
		width: ${(props) => IMAGE_SIZES[props.size]};
		/* height: ${(props) => IMAGE_SIZES[props.size]}; */
		border-radius: 4px;
	}

	p.artist-name {
		font-weight: bold;
		font-size: ${(props) => FONT_SIZES[props.size]};
		line-height: ${(props) => FONT_SIZES[props.size]};
	}

	div.artist-genres {
		display: flex;
		flex-wrap: wrap;
	}

	span.artist-genre-chip {
		font-size: 0.8rem;
		line-height: 1rem;
		border-radius: 4px;
		background: var(--color-tertiary);
		color: var(--color-dark-background);
	}

	${bpMaxMD} {
		align-items: center;
		flex-direction: column;
		justify-content: center;

		div.artist-image img {
			border-radius: 50%;
			height: ${(props) => IMAGE_SIZES[props.size]};
		}

		p.artist-name {
			font-size: 2rem;
			text-align: center;
		}

		div.artist-genres {
			align-items: center;
			justify-content: center;
		}
	}
`;

const GenreChips = ({ genres }) => {
	return genres.map((genre) => (
		<span key={genre} className="artist-genre-chip py-1 px-2 my-2 mr-2">
			{genre}
		</span>
	));
};

const ArtistPreview = (props) => {
	const { size, artist, isLastArtist } = props;
	const { name, images, genres, external_urls } = artist;

	// const image = getImage(images, size);
	const containerClass = isLastArtist
		? 'py-4'
		: 'py-4 border-b-1 border-gray-100';

	return (
		<Container size={size} className={containerClass}>
			<div className="artist-image md:pr-4">
				<a href={external_urls.spotify}>
					<img src={images[2].url} alt={name} />
				</a>
			</div>
			<div className="artist-info p-2">
				<p className="artist-name pb-2">{name}</p>
				<div className="artist-genres">
					<GenreChips genres={genres} />
				</div>
			</div>
		</Container>
	);
};

export default ArtistPreview;
